export default {
  'get-list': {
    method: 'post',
    url: '/driver/list'
  },
  add: {
    method: 'post',
    url: '/driver'
  },
  delete: {
    method: 'delete',
    url: '/driver'
  },
  update: {
    method: 'put',
    url: '/driver/ID'
  },
  get: {
    method: 'get',
    url: '/driver/ID'
  },
  changeStatus: {
    method: 'put',
    url: '/driver/status'
  },
  select: {
    method: 'get',
    url: '/driver/find?key=KEY'
  },
  archive: {
    method: 'delete',
    url: '/driver/archive'
  },
  restore: {
    method: 'put',
    url: '/driver/restore'
  },
  selectByLicenseType: {
    method: 'get',
    url: '/driver/find'
  }
}
